import { BasePagination } from "api/interfaces/commonInterface.interface";
import { CommonTable } from "components/atoms/table/AntdTable";
import { TableTemplate } from "components/templates/default/table/TableTemplate";
import React from "react";
import { DataRow } from "pages/recorders/recorders/list/RecorderListContainer";
import { TableColumnsType } from "antd";
import { RecorderConfig } from "api/interfaces/recorderInterface.interface";
import CovaConfiguration from "pages/recorders/configuration";

type Props = {
  columns: TableColumnsType<DataRow>;
  data: Array<DataRow>;
  paginationInfo: BasePagination;
  onChangePage: (page: number, totalRows: number) => void;
  initialPending: boolean;
  configureInfo: RecorderConfig | null;
  onConfigureModal: () => void;
  centerChildren: React.ReactNode;
  keyword: string;
  onClickSearch: (keyword: string) => void;
};
export default function ConfigurationPresenter({
  columns,
  data,
  paginationInfo,
  onChangePage,
  initialPending,
  configureInfo,
  onConfigureModal,
  centerChildren,
  keyword,
  onClickSearch,
}: Props): JSX.Element {
  return (
    <>
      <TableTemplate
        titleComponent={"COVA Config Download"}
        centerChildren={centerChildren}
        keyword={keyword}
        onClickSearch={onClickSearch}
      >
        <CommonTable
          columns={columns}
          dataSource={data}
          queryInfo={paginationInfo}
          onChangePage={onChangePage}
          loading={initialPending}
          rowClassName="noPointer"
        />
      </TableTemplate>
      {configureInfo && (
        <CovaConfiguration
          onModal={onConfigureModal}
          configureInfo={configureInfo}
        />
      )}
    </>
  );
}
